import api from '../config/api';

const paymentAPI = {
  createCheckoutSession: async (orderId, successUrl, cancelUrl) => {
    try {
      const res = await api.post('/payment/create-checkout-session', { orderId, successUrl, cancelUrl });
      return res.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  verifySession: async (sessionId) => {
    try {
      const res = await api.post('/payment/verify-session', { sessionId });
      return res.data;
    } catch (error) {
      console.error('Error verifying session:', error);
      throw error;
    }
  }
};

export default paymentAPI;
